import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './auth/AuthContext.jsx';
import { loadBranding, site } from './config/site.js';
import './styles/app.css';

// Branding zuerst holen, damit Titel und Name nicht sichtbar umspringen.
loadBranding().finally(() => {
  document.documentElement.style.setProperty('--accent', site.themeColor);

  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>
  );
});
